// extracted by mini-css-extract-plugin
export default {"noData":"efficiency_noData__3iHOM"};